module.exports = __webpack_public_path__ + "static/img/sync.2459396c.svg";